import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAgreementGate } from './useAgreementGate';

/** Wraps routes a partner cannot use before e-signing the agreement (deep links included). */
const RequireAgreementSigned: React.FC<{ children?: React.ReactElement }> = ({ children }) => {
  const { locked, openPopup } = useAgreementGate();

  useEffect(() => {
    if (locked) {
      openPopup();
    }
  }, [locked, openPopup]);

  if (locked) {
    return <Navigate to="/deals" replace />;
  }
  return children ?? <Outlet />;
};

export default RequireAgreementSigned;
